import { CLASS_CATEGORY_QUERY_KEYS, CLASS_QUERY_KEYS } from '@/constants';
import { createEntityCrudHooks } from './createEntityCrudHooks';

export interface ClassCategory {
  id: string;
  title: string;
  created_by_name: string;
  created_by_email: string;
  created_at: string;
  updated_at: string;
}

export interface CreateClassCategoryData {
  title: string;
}

export interface UpdateClassCategoryData {
  title: string;
}

const hooks = createEntityCrudHooks<ClassCategory, CreateClassCategoryData, UpdateClassCategoryData>({
  table: 'class_categories',
  entityType: 'class_category',
  label: 'class category',
  labelPlural: 'class categories',
  pascalName: 'ClassCategory',
  allKey: CLASS_CATEGORY_QUERY_KEYS.ALL,
  byId: (id) => CLASS_CATEGORY_QUERY_KEYS.BY_ID(id),
  relatedKeysOnDelete: [CLASS_QUERY_KEYS.ALL],
});

export const useClassCategories = hooks.useList;
export const useClassCategory = hooks.useOne;
export const useCreateClassCategory = hooks.useCreate;
export const useUpdateClassCategory = hooks.useUpdate;
export const useDeleteClassCategory = hooks.useDelete;
